module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/178-palau-63bbdd17037743a31a7fc1774ac197d2.svg";